/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */



(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  /******** Envision - comment out placeholder code, leaving it in for future reference

  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container: ' + container);
      console.log('Variant: ' + variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart: ' + cart);
      // ... update an app or a custom shipping caluclator
    }
  });

  // Debounced scroll listeners.  Up and down only fire on directions changes
  // These events are useful for creating sticky headers and footers.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  ********/

  // Envision - when variant is changed, update hidden _presale property input, Made to Order property input depending on variant inventory quantity.
  document.addEventListener("theme:variant:change", function (event) {
    //console.log('event variant change')
    var variant = event.detail.variant;
    //console.log('variant ', variant)
    var container = event.target;
    const color = variant?.option1;
    const feather_type = variant?.option2;
   
    //validateFeatherType(color);
    //validateSize(feather_type);

    if (variant && container) {
      var presale_property_input = container.querySelector(
        '[name^="properties[_presale]"]'
      );
      var madetoorder_input = container.querySelector(
        '[name^="properties[Made to Order]"]'
      );
      var preorder_message =
        "This product is being made to order and requires an additional 1 - 2 weeks lead time. Once complete, your order will ship in full via your selected shipping service.";

      var buttonState = null;
      var statesEl = container.querySelector("[data-variant-button-states]");
      if (statesEl) {
        try {
          var states = JSON.parse(statesEl.textContent);
          buttonState = states[variant.id.toString()];
        } catch (e) {}
      }
      if (!buttonState) {
        var iq = variant.inventory_quantity;
        if ((iq === 0 || iq === "0") && variant.inventory_policy === "continue") {
          buttonState = "made_to_order";
        } else {
          buttonState = iq > 0 ? "add_to_cart" : "waitlist";
        }
      }
      var isMadeToOrder = buttonState === "made_to_order";

      if (presale_property_input) {
        presale_property_input.value = isMadeToOrder ? "true" : "false";

        // Asegurar propiedad Made to Order
        if (isMadeToOrder) {
          if (madetoorder_input) {
            madetoorder_input.value = preorder_message;
          } else {
            var newInput = document.createElement("input");
            newInput.type = "hidden";
            newInput.name = "properties[Made to Order]";
            newInput.value = preorder_message;
            presale_property_input.parentNode.insertBefore(newInput, presale_property_input.nextSibling);
          }
        } else if (madetoorder_input) {
          madetoorder_input.remove();
        }

        presale_property_input.dispatchEvent(new Event("change"));
      }
    }
  });
})();



/*
function validateFeatherType(color = null){
  const product__variants_hidden = document.getElementById('product__variants_hidden');
  const variants_json = product__variants_hidden.value;
  const variants = JSON.parse(variants_json);
  const feather_type_available = [];
  const size_available = [];
  const swatchers = document.querySelectorAll('[data-swatch-filename]');
  //activamos todos los elementos
  for (const swatcher of swatchers) { 
    swatcher.style.display = 'block';
  }

  for (const variant of variants) {
    if(variant.option1 == color){
      feather_type_available.push(variant.option2);
      size_available.push(variant.option3);
    }
  }

  const unique_feather_type_available = [...new Set(feather_type_available)];

  //ocultamos los que no estan en el color
  for (const swatcher of swatchers) {
    const swatcher_filename = swatcher.getAttribute('data-swatch-filename');
    const swatcher_filename_santized = capitalize(swatcher_filename.replace('.png', ''));
    
    if (!unique_feather_type_available.includes(swatcher_filename_santized)) {
      swatcher.style.display = 'none';
    }
  }
}
*/
/*
function validateSize(feather_type = null){
  const product__variants_hidden = document.getElementById('product__variants_hidden');
  const variants_json = product__variants_hidden.value;
  const variants = JSON.parse(variants_json);
  const size_available = [];
  const swatchers = document.querySelectorAll('[data-size]');
  //activamos todos los elementos
  for (const swatcher of  swatchers) {
    console.log('swatcher', swatcher);
    swatcher.style.display = 'inline-block';
  }

  for (const variant of variants) {
    if(variant.option2 == feather_type){
      size_available.push(variant.option3);
    }
  }

  const unique_size_available = [...new Set(size_available)];

  //ocultamos los que no estan en el color
  for (const swatcher of swatchers) {
    const swatcher_size_name = swatcher.getAttribute('data-size');
    console.log('unique_size_available', unique_size_available)
    console.log('swatcher_size_name ', swatcher_size_name);
    
    if (!unique_size_available.includes(swatcher_size_name)) {
      swatcher.style.display = 'none';
    }
  }

}
*/
function capitalize(s)
{
    return s[0].toUpperCase() + s.slice(1);
}

jQuery(function ($) {
  window.onload = update_madetoorder_status;
  function update_madetoorder_status() {
    if ($(".product-data-group").length) {
      if ($(".product-data-group input").length) {
        $(".product-data-group input").each(function (index, obj) {
          var handle = $(obj).attr("data-product-handle");
          var real_qty = $(obj).val();
          var selector = "form[data-product-handle='" + handle + "']";
          if ($(selector).length) {
            $(selector + " input#inventory_quantity").attr("data", real_qty);
            var available = $(selector + " input#available").attr("data");
            var preorder_threshold = $(
              selector + " input#preorder_threshold"
            ).attr("data");
            var inventory_policy = $(selector + " input#inventory_policy").attr(
              "data"
            );
            if (
              available == "true" &&
              parseInt(real_qty) === 0 &&
              inventory_policy == "continue"
            ) {
              var preorder_message =
                "This product is being made to order and requires an additional 1 - 2 weeks lead time. Once complete, your order will ship in full via your selected shipping service.";
              if ($(selector + " input#preorder-property").length) {
                $(selector + " input#preorder-property").attr(
                  "name",
                  "properties[Made to Order]"
                );
                $(selector + " input#preorder-property").val(preorder_message);
              } else {
                var elem =
                  '<input id="preorder-property" type="hidden" name="properties[Made to Order]" value="' +
                  preorder_message +
                  '">';
                $(selector).append(elem);
              }
              $(selector + " button span.data-add-to-cart-text").text(
                "Made To Order"
              );
            }
            var presaleInput = $(selector).find('[name^="properties[_presale]"]');
            if(presaleInput.length){
              presaleInput.val(parseInt(real_qty) === 0 ? "true" : "false");
            }
            
          }
        });
      }
    }
  }
  $(".page.current").on("DOMSubtreeModified", function (e) {
    alert();
  });
  /*
    $(".collection__products.filtered").on('click', '.collection-add-to-cart', function(e){
      e.preventDefault();
      
      var handle = $(this).attr('data-product-handle');
      var quantity_selector = "input[data-product-handle='" + handle + "']";
      var real_quantity = $(quantity_selector).val();
      var available = $(this).closest('form').find("#available").attr("data");
      var preorder_threshold = $(this).closest('form').find("#preorder_threshold").attr("data");
      var inventory_policy = $(this).closest('form').find("#inventory_policy").attr("data");
      console.log("available", available);
      console.log("real_quantity", real_quantity);
      console.log("preorder_threshold", preorder_threshold);
      console.log("inventory_policy", inventory_policy);
      if( available == "true" && real_quantity <= preorder_threshold && inventory_policy == "CONTINUE"){
      	$(this).closest('form').find("#preorder-property").attr('name', 'properties[Made to Order]').val("This product is being made to order and requires additional time. Once complete, your order will ship in full via your selected shipping service.");
      	//$(this).find('span').text("Made to order");
      }
      if( real_quantity <= preorder_threshold ){
      	$(this).closest('form').find("#_presale").attr('name', 'properties[_presale]').val("true");
      }else{
      	$(this).closest('form').find("#_presale").attr('name', 'properties[_presale]').val("false");
      }
//       alert($(this).closest('form').find("#preorder-property").val());
      $(this).closest('form').submit();
    });
*/
});

// Product Options Quantity Selector Functionality
(function() {
  'use strict';
  // Function to get main product quantity
  function getMainProductQuantity() {
    const mainQuantityInput = document.querySelector('[data-quantity-input]');
    return mainQuantityInput ? parseInt(mainQuantityInput.value) || 1 : 1;
  }

  // Function to update addon quantity limits based on main product quantity
  function updateAddonQuantityLimits() {
    const mainQuantity = getMainProductQuantity();
    const addonQuantityInputs = document.querySelectorAll('.product-option__quantity-input');
    
    addonQuantityInputs.forEach(function(input) {
      const currentValue = parseInt(input.value) || 1;
      const optionId = input.getAttribute('data-option-id');
      const quantityWrapper = input.closest('.product-option__quantity-wrapper');
      const checkbox = document.querySelector('.product-option__checkbox[data-option-id="' + optionId + '"]');
      
      // Update max attribute
      input.setAttribute('max', mainQuantity);
      
      // Show/hide quantity selector based on main product quantity
      if (mainQuantity <= 1) {
        // Hide quantity selector when main product quantity is 1 or less
        if (quantityWrapper && checkbox && checkbox.checked) {
          quantityWrapper.style.display = 'none';
        }
        // Set addon quantity to 1 when main product is 1
        input.value = 1;
        const hiddenQuantityInput = document.querySelector('#product-option-quantity-hidden--' + optionId);
        if (hiddenQuantityInput && checkbox && checkbox.checked) {
          hiddenQuantityInput.value = '1';
          // Ensure name attribute is set when checkbox is checked
          const propertyName = hiddenQuantityInput.getAttribute('data-property-name');
          if (propertyName && !hiddenQuantityInput.hasAttribute('name')) {
            hiddenQuantityInput.setAttribute('name', 'properties[' + propertyName + ']');
          }
        }
        updateRepeaterFields(optionId, 1);
      } else {
        // Show quantity selector when main product quantity is greater than 1
        if (quantityWrapper && checkbox && checkbox.checked) {
          quantityWrapper.style.display = 'block';
        }
        
        // If current value exceeds new max, adjust it
        if (currentValue > mainQuantity) {
          input.value = mainQuantity;
          
          // Update hidden field as well
          const hiddenQuantityInput = document.querySelector('#product-option-quantity-hidden--' + optionId);
          if (hiddenQuantityInput && checkbox && checkbox.checked) {
            hiddenQuantityInput.value = mainQuantity;
            // Ensure name attribute is set when checkbox is checked
            const propertyName = hiddenQuantityInput.getAttribute('data-property-name');
            if (propertyName && !hiddenQuantityInput.hasAttribute('name')) {
              hiddenQuantityInput.setAttribute('name', 'properties[' + propertyName + ']');
            }
          }
          
          // Update repeater fields based on new quantity
          updateRepeaterFields(optionId, mainQuantity);
        }
      }
    });
  }

  // Initialize product options quantity selectors
  function initProductOptionsQuantity() {
    // Handle checkbox changes to show/hide quantity selector
    document.addEventListener('change', function(e) {
      if (e.target.classList.contains('product-option__checkbox')) {
        const optionId = e.target.getAttribute('data-option-id');
        const quantityWrapper = document.querySelector('.product-option__quantity-wrapper[data-option-id="' + optionId + '"]') ||
                               e.target.closest('.product-option__wrapper').querySelector('.product-option__quantity-wrapper');
        
        if (quantityWrapper) {
          const quantityInput = quantityWrapper.querySelector('.product-option__quantity-input');
          const hiddenQuantityInput = quantityWrapper.querySelector('#product-option-quantity-hidden--' + optionId);
          
          if (e.target.checked) {
            const mainQuantity = getMainProductQuantity();
            // Only show quantity selector if main product quantity > 1
            if (mainQuantity > 1) {
              quantityWrapper.style.display = 'block';
            } else {
              quantityWrapper.style.display = 'none';
            }
            // Update addon limits when showing
            updateAddonQuantityLimits();
            // Update hidden field with current quantity and enable it
            if (hiddenQuantityInput && quantityInput) {
              hiddenQuantityInput.value = quantityInput.value;
              // Restore the name attribute to include it in form submission
              const propertyName = hiddenQuantityInput.getAttribute('data-property-name');
              if (propertyName) {
                hiddenQuantityInput.setAttribute('name', 'properties[' + propertyName + ']');
              }
            }
          } else {
            quantityWrapper.style.display = 'none';
            // Reset quantity to 1 when unchecked
            if (quantityInput) {
              quantityInput.value = 1;
            }
            // Remove name attribute to prevent empty value from being submitted
            if (hiddenQuantityInput) {
              hiddenQuantityInput.value = '';
              hiddenQuantityInput.removeAttribute('name');
            }
          }
        }
      }
    });

    // Listen for changes in main product quantity
    document.addEventListener('change', function(e) {
      if (e.target.matches('[data-quantity-input]')) {
        updateAddonQuantityLimits();
      }
    });

    // Listen for main product quantity changes via buttons
    document.addEventListener('click', function(e) {
      if (e.target.matches('.js-qty__adjust')) {
        // Use setTimeout to ensure the quantity input value is updated first
        setTimeout(updateAddonQuantityLimits, 10);
      }
    });

    // Handle quantity button clicks
    document.addEventListener('click', function(e) {
      if (e.target.classList.contains('product-option__quantity-btn')) {
        e.preventDefault();
        const optionId = e.target.getAttribute('data-option-id');
        const quantityInput = document.querySelector('#product-option-quantity--' + optionId);
        
        if (quantityInput) {
          let currentValue = parseInt(quantityInput.value) || 1;
          const min = parseInt(quantityInput.getAttribute('min')) || 1;
          // Get dynamic max based on main product quantity
          const mainQuantity = getMainProductQuantity();
          const max = Math.min(parseInt(quantityInput.getAttribute('max')) || 99, mainQuantity);
          
          if (e.target.classList.contains('product-option__quantity-btn--plus')) {
            if (currentValue < max) {
              quantityInput.value = currentValue + 1;
            }
          } else if (e.target.classList.contains('product-option__quantity-btn--minus')) {
            if (currentValue > min) {
              quantityInput.value = currentValue - 1;
            }
          }
          
          // Update hidden field with new quantity
          const hiddenQuantityInput = document.querySelector('#product-option-quantity-hidden--' + optionId);
          if (hiddenQuantityInput) {
            hiddenQuantityInput.value = quantityInput.value;
            // Ensure name attribute is set (checkbox should be checked if we're here)
            const propertyName = hiddenQuantityInput.getAttribute('data-property-name');
            if (propertyName && !hiddenQuantityInput.hasAttribute('name')) {
              hiddenQuantityInput.setAttribute('name', 'properties[' + propertyName + ']');
            }
          }
          
          // Update repeater fields based on new quantity
          updateRepeaterFields(optionId, parseInt(quantityInput.value));
          
          // Trigger change event for any listeners
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    // Handle direct input changes
    document.addEventListener('input', function(e) {
      if (e.target.classList.contains('product-option__quantity-input')) {
        const min = parseInt(e.target.getAttribute('min')) || 1;
        // Get dynamic max based on main product quantity
        const mainQuantity = getMainProductQuantity();
        const max = Math.min(parseInt(e.target.getAttribute('max')) || 99, mainQuantity);
        let value = parseInt(e.target.value) || min;
        
        // Ensure value is within bounds
        if (value < min) {
          e.target.value = min;
        } else if (value > max) {
          e.target.value = max;
        }
        
        // Update hidden field with new quantity
        const optionId = e.target.getAttribute('data-option-id');
        const hiddenQuantityInput = document.querySelector('#product-option-quantity-hidden--' + optionId);
        if (hiddenQuantityInput) {
          hiddenQuantityInput.value = e.target.value;
          // Ensure name attribute is set (checkbox should be checked if we're here)
          const propertyName = hiddenQuantityInput.getAttribute('data-property-name');
          if (propertyName && !hiddenQuantityInput.hasAttribute('name')) {
            hiddenQuantityInput.setAttribute('name', 'properties[' + propertyName + ']');
          }
        }
        
        // Update repeater fields based on new quantity
        updateRepeaterFields(optionId, parseInt(e.target.value));
      }
    });
  }

  // Function to get product option quantity for integration with existing cart system
  window.getProductOptionQuantity = function(optionId) {
    const checkbox = document.querySelector('.product-option__checkbox[data-option-id="' + optionId + '"]');
    const quantityInput = document.querySelector('#product-option-quantity--' + optionId);
    
    // Only return quantity if checkbox is checked
    if (checkbox && checkbox.checked && quantityInput) {
      const mainQuantity = getMainProductQuantity();
      
      // If main product quantity is 1, return 1 (selector is hidden but addon should have quantity 1)
      if (mainQuantity <= 1) {
        return 1;
      }
      
      // If main product quantity > 1, return the selected quantity (selector is visible)
      return parseInt(quantityInput.value) || 1;
    }
    return 0; // Return 0 if not selected, so it won't be added to cart
  };

  // Function to get modified product title with quantity
  window.getProductOptionTitleWithQuantity = function(optionId) {
    const checkbox = document.querySelector('.product-option__checkbox[data-option-id="' + optionId + '"]');
    const quantityInput = document.querySelector('#product-option-quantity--' + optionId);
    const originalTitleInput = document.querySelector('#product-option-title-hidden--' + optionId);
    
    if (checkbox && checkbox.checked && quantityInput && originalTitleInput) {
      const quantity = parseInt(quantityInput.value) || 1;
      const originalTitle = originalTitleInput.value;
      
      if (quantity > 1) {
        return originalTitle + ': ' + quantity;
      } else {
        return originalTitle;
      }
    }
    return null;
  };

  // Function to add quantity to cart product option titles and hide quantity properties
  window.updateCartDrawerQuantityDisplay = function() {
    // Function to process cart items
    function processCartItems() {
      // Look for both rebuy cart items and regular cart product options
      const cartItems = document.querySelectorAll('.rebuy-cart__flyout-item, .cart-product-option');
      
      cartItems.forEach(function(item) {
        // Find the title element - could be in different structures
        let titleElement = item.querySelector('.cart-product-option__title');
        if (!titleElement) {
          titleElement = item.querySelector('.cart-product-option__name');
        }
        
        // Find quantity property elements - try different selectors
        let quantityProperties = item.querySelectorAll('.rebuy-cart__flyout-item-property');
        if (quantityProperties.length === 0) {
          quantityProperties = item.querySelectorAll('.cart-product-option-details .property');
        }
        
        quantityProperties.forEach(function(propertyRow) {
          let propertyKeyElement = propertyRow.querySelector('[class*="property-key"]');
          let propertyValueElement = propertyRow.querySelector('[class*="property-value"]');
          
          // Try alternative selectors if not found
          if (!propertyKeyElement) {
            propertyKeyElement = propertyRow.querySelector('.property-name');
          }
          if (!propertyValueElement) {
            propertyValueElement = propertyRow.querySelector('.property-value');
          }
          
          if (propertyKeyElement && propertyValueElement) {
            const propertyKey = propertyKeyElement.textContent.trim().toLowerCase();
            const propertyValue = propertyValueElement.textContent.trim();
            
            // Check if this is a quantity property
            if (propertyKey.includes('quantity')) {
              // Hide the property row
              propertyRow.style.display = 'none';
              
              // Add quantity to the title element if it exists
              if (titleElement && propertyValue) {
                const currentTitle = titleElement.textContent.trim();
                
                // Only add quantity if it's not already there
                if (!currentTitle.includes(' ' + propertyValue) && !currentTitle.includes(': ' + propertyValue)) {
                  // Clean the title first (remove any existing quantity)
                  let cleanTitle = currentTitle;
                  cleanTitle = cleanTitle.replace(/\s+\d+$/, ''); // Remove numbers at the end
                  cleanTitle = cleanTitle.replace(/:\s*\d+$/, ''); // Remove ": number" at the end
                  
                  // Add the quantity to the title
                  titleElement.textContent = cleanTitle + ' ' + propertyValue;
                }
              }
            }
          }
        });
      });
      
      // Also try to find and update cart product options directly
      const directCartOptions = document.querySelectorAll('.cart-product-option');
      directCartOptions.forEach(function(option) {
        const nameElement = option.querySelector('.cart-product-option__name');
        if (nameElement && nameElement.textContent.includes('Gift Wrap')) {
          console.log('Found Gift Wrap element:', nameElement);
          // Try to find quantity in the option's properties
          const properties = option.querySelectorAll('.cart-product-option-details .property');
          properties.forEach(function(prop) {
            const text = prop.textContent.toLowerCase();
            if (text.includes('quantity')) {
              console.log('Found quantity property:', prop.textContent);
            }
          });
        }
      });
    }
    
    // Run immediately
    processCartItems();
    
    // Also run after a short delay to catch any late updates
    setTimeout(processCartItems, 100);
    setTimeout(processCartItems, 300);
    setTimeout(processCartItems, 800);
  };

  // Function to reset all product option quantities (called after successful cart add)
  window.resetProductOptionQuantities = function() {
    const quantityInputs = document.querySelectorAll('.product-option__quantity-input');
    quantityInputs.forEach(function(input) {
      input.value = 1;
    });
    const quantityWrappers = document.querySelectorAll('.product-option__quantity-wrapper');
    quantityWrappers.forEach(function(wrapper) {
      wrapper.style.display = 'none';
    });
    // Also reset hidden quantity fields and remove name attribute
    const hiddenQuantityInputs = document.querySelectorAll('input[id^="product-option-quantity-hidden--"]');
    hiddenQuantityInputs.forEach(function(input) {
      input.value = '';
      input.removeAttribute('name');
    });
    // Reset repeater fields to single item
    const repeaterContainers = document.querySelectorAll('[data-repeater-container]');
    repeaterContainers.forEach(function(container) {
      const optionId = container.getAttribute('data-repeater-container');
      updateRepeaterFields(optionId, 1);
    });
  };

  // Function to update repeater fields based on quantity
  function updateRepeaterFields(optionId, quantity) {
    const repeaterContainer = document.querySelector('[data-repeater-container="' + optionId + '"]');
    if (!repeaterContainer) return;

    const currentItems = repeaterContainer.querySelectorAll('.product-option__details-item');
    const currentCount = currentItems.length;
    
    // Get base info from first item
    const firstItem = currentItems[0];
    if (!firstItem) return;
    
    const firstTextarea = firstItem.querySelector('.product-option__textarea');
    const baseName = firstTextarea.getAttribute('data-base-name');
    const placeholder = firstTextarea.getAttribute('placeholder');
    const maxLength = firstTextarea.getAttribute('maxlength');
    const required = firstTextarea.hasAttribute('required');
    
    
    if (quantity > currentCount) {
      // Add more fields
      for (let i = currentCount + 1; i <= quantity; i++) {
        const newItem = document.createElement('div');
        newItem.className = 'product-option__details-item';
        newItem.setAttribute('data-item-index', i);
        
        const textarea = document.createElement('textarea');
        textarea.id = baseName + '-' + i;
        textarea.className = 'product-option__textarea';
        textarea.name = baseName + '-' + i;
        textarea.setAttribute('data-base-name', baseName);
        textarea.setAttribute('data-option-id', optionId);
        textarea.setAttribute('data-item-index', i);
        textarea.setAttribute('placeholder', placeholder);
        if (maxLength) textarea.setAttribute('maxlength', maxLength);
        if (required) textarea.setAttribute('required', 'required');
        
        newItem.appendChild(textarea);
        repeaterContainer.appendChild(newItem);
      }
    } else if (quantity < currentCount) {
      // Remove excess fields
      for (let i = currentCount; i > quantity; i--) {
        const itemToRemove = repeaterContainer.querySelector('[data-item-index="' + i + '"]');
        if (itemToRemove) {
          itemToRemove.remove();
        }
      }
    }
    
    repeaterContainer.setAttribute('data-single-item', quantity === 1 ? 'true' : 'false');
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initProductOptionsQuantity();
      // Set initial limits based on main product quantity
      updateAddonQuantityLimits();
    });
  } else {
    initProductOptionsQuantity();
    // Set initial limits based on main product quantity
    updateAddonQuantityLimits();
  }
})();

// Integración suave con Product Personalizer (Zepto):
// Cuando el app termine su propio Add to Cart (embroidery + producto),
// escuchamos el evento pplrAddToCartCompleted, asignamos un _UUID a la
// línea principal añadida por Zepto y luego añadimos SOLO nuestros
// add-ons (Gift Wrap, Box, etc.) mediante window.addProductOptionsOnly(uuid).
(function() {
  'use strict';

  if (typeof window === 'undefined') return;

  function generateUUID() {
    // Reutilizar uuid() global si existe
    if (typeof window.uuid === 'function') {
      return window.uuid();
    }
    // Fallback simple
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  try {
    window.addEventListener('pplrAddToCartCompleted', function(e) {
      try {
        // 1) Leer carrito actualizado: Zepto ya ha añadido su línea
        fetch('/cart.js')
          .then(function(res) { return res.json(); })
          .then(function(cart) {
            if (!cart || !cart.items || !cart.items.length) {
              console.warn('[PP] Cart vacío tras pplrAddToCartCompleted');
              return null;
            }

            // Suponemos que la última línea añadida es la de Zepto
            var lastIndex = cart.items.length - 1;
            var lastItem = cart.items[lastIndex];
            if (!lastItem) {
              return null;
            }

            var uuid = generateUUID();

            // 2) Asignar _UUID al ítem principal de Zepto vía /cart/change.js
            var changePayload = {
              line: lastIndex + 1, // API usa 1-based index
              properties: Object.assign({}, lastItem.properties || {}, {
                _UUID: uuid
              })
            };

            return fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json; charset=UTF-8'
              },
              body: JSON.stringify(changePayload)
            }).then(function() {
              return uuid;
            });
          })
          .then(function(uuid) {
            if (!uuid) {
              // No UUID asignado, salir sin añadir add-ons
              return;
            }

            // 3) Añadir SOLO nuestros add-ons vinculados a ese _UUID
            if (typeof window.addProductOptionsOnly === 'function') {
              window.addProductOptionsOnly(uuid);
            } else {
              console.warn('[PP] pplrAddToCartCompleted: addProductOptionsOnly no está definido');
            }
          })
          .catch(function(err) {
            console.error('[PP] Error en flujo pplrAddToCartCompleted + addProductOptionsOnly', err);
          });
      } catch (innerErr) {
        console.error('[PP] Error inicial al manejar pplrAddToCartCompleted', innerErr);
      }
    });
  } catch (err) {
    console.error('[PP] Error registrando listener de pplrAddToCartCompleted', err);
  }
})();
